import {DialogController} from 'aurelia-dialog';
import { I18N } from 'aurelia-i18n';
  
export class LegalTermsDialog {
	static inject = [DialogController, I18N];

	constructor(public controller, private i18n) { }

	activate() {
	}
}
